module.exports = __webpack_public_path__ + "img/a1fac8b.png";